import { useContext } from 'react';

import { AmplifyUserContext } from './AmplifyUserProvider';

export const useAmplifyUser = () => {
  const context = useContext(AmplifyUserContext);

  if (!context) {
    throw new Error(
      'useAmplifyUser must be used within an AmplifyUserProvider',
    );
  }

  return context;
};
